import { useQuery } from '@tanstack/react-query';
import { FieldValues } from 'react-hook-form';

import { articleTypeOptions } from '@/module/Nomen/ArticleType/model/ArticleTypeModel';

import { AsyncSelectControl, AsyncSelectControlProps } from '@/core/components';

type ArticleTypeSelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
>;

export function ArticleTypeSelectControl<T extends FieldValues>(props: ArticleTypeSelectControlProps<T>) {
  const { data, isLoading, isError } = useQuery(articleTypeOptions.getAll());

  return (
    <AsyncSelectControl
      isError={isError}
      isLoading={isLoading}
      options={data ?? []}
      {...props}
    />
  );
}
